@if (pageReady) {
  <main class="gs-page">
    <div class="schedule-service-container">
      <app-page-header [headerData]="pageHeader"></app-page-header>
      <div class="gs-content-container">
        <div class="notification-container">
          <app-notification></app-notification>
        </div>
        <app-ssm-stepper [process]="process" [step]="step"></app-ssm-stepper>
        <div class="schedule-service-main-container">
          <div class="schedule-service-form-container">
            @if (!hasEmail && process === "reconnect") {
              <div class="email-form">
                <h2>{{ pageLabels.emailHeader }}</h2>
                <app-email-form [emailData]="emailFormData"></app-email-form>
                <p class="email-disclaimer">{{ pageLabels.emailDisclaimer }}</p>
              </div>
            }
            <div class="header-section">
              <h2>{{ pageLabels.header }}</h2>
            </div>
            <form [formGroup]="scheduleServiceForm">
              <mat-radio-group
                class="gs-radio-button"
                color="primary"
                formControlName="ServiceOption"
                aria-labelledby="serviceOptionRequiredError"
              >
                <mat-radio-button value="turn-on" class="schedule-radio"
                  ><p [innerHTML]="pageLabels.turnOnOptionText | safe: 'SafeHtml'"></p
                ></mat-radio-button>
                @if (scheduleServiceForm.get("ServiceOption")?.value === "turn-on") {
                  <div class="turn-on-container">
                    <h3>{{ pageLabels.turnOnHeader }}</h3>
                    <p>{{ pageLabels.turnOnSubHeader }}</p>
                    <mat-radio-group
                      class="gs-radio-button"
                      color="primary"
                      formControlName="DateOption"
                      aria-labelledby="dateOptionRequiredError"
                    >
                      <mat-radio-button value="first" class="schedule-radio"
                        ><p [innerHTML]="pageLabels.firstAvailableOptionText"></p
                      ></mat-radio-button>
                      <mat-radio-button value="choose" class="schedule-radio">{{
                        pageLabels.chooseOptionText
                      }}</mat-radio-button>
                    </mat-radio-group>
                    @if (
                      scheduleServiceForm.get("DateOption")?.hasError("required") &&
                      scheduleServiceForm.get("DateOption")?.touched
                    ) {
                      <mat-error id="dateOptionRequiredError">{{ pageLabels.selectDateOptionError }}</mat-error>
                    }
                    @if (scheduleServiceForm.get("DateOption")?.value === "choose") {
                      <div class="schedule-calendar-container">
                        <mat-form-field appearance="outline" color="primary" class="schedule-calendar schedule-input">
                          <mat-label>{{ pageLabels.chooseDateLabel }}</mat-label>
                          <input
                            matInput
                            [matDatepickerFilter]="dateFilter"
                            [matDatepicker]="picker"
                            placeholder="MM/DD/YYYY"
                            formControlName="Date"
                            [min]="startDate"
                            [max]="maxDate"
                          />
                          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                          <mat-datepicker #picker (opened)="onDatepickerOpened(picker)" (closed)="onDatepickerClosed()">
                          </mat-datepicker>
                          @if (scheduleServiceForm.get("Date")?.hasError("required")) {
                            <mat-error id="dateRequired">{{ pageLabels.dateRequiredError }}</mat-error>
                          }
                          @if (scheduleServiceForm.get("Date")?.hasError("matDatepickerMin")) {
                            <mat-error id="minDateError">{{ pageLabels.minDateError }}</mat-error>
                          }
                          @if (scheduleServiceForm.get("Date")?.hasError("matDatepickerMax")) {
                            <mat-error id="maxDateError">{{ pageLabels.maxDateError }}</mat-error>
                          }
                        </mat-form-field>
                        <p>{{ pageLabels.chooseTimeHeader }}</p>
                        <mat-radio-group
                          class="gs-radio-button inline-radio"
                          color="primary"
                          formControlName="TimeOption"
                          aria-labelledby="timeRequired"
                        >
                          <mat-radio-button value="morning" class="schedule-radio">{{
                            pageLabels.morningOptionText
                          }}</mat-radio-button>
                          <mat-radio-button value="afternoon" class="schedule-radio">{{
                            pageLabels.afternoonOptionText
                          }}</mat-radio-button>
                        </mat-radio-group>
                        @if (
                          scheduleServiceForm.get("TimeOption")?.touched &&
                          scheduleServiceForm.get("TimeOption")?.hasError("required")
                        ) {
                          <mat-error id="timeRequired">{{ pageLabels.timeRequiredError }}</mat-error>
                        }
                        <mat-checkbox class="schedule-cb" formControlName="Saturday" color="primary"
                          >{{ pageLabels.saturdayLabelText
                          }}<i
                            #tooltip="matTooltip"
                            matTooltip="{{ pageLabels.saturdayTooltip }}"
                            matTooltipPosition="below"
                            matTooltipClass="gs-tooltip"
                            (click)="$event.preventDefault(); $event.stopImmediatePropagation(); tooltip.toggle()"
                            (keydown.enter)="tooltip.toggle()"
                            tabindex="0"
                            [attr.aria-label]="pageLabels.saturdayTooltip"
                            role="tooltip"
                            class="gs-tooltip-icon fa-solid fa-circle-question"
                          ></i
                        ></mat-checkbox>
                      </div>
                    }
                    <p>
                      <em>{{ pageLabels.presenceRequiredDisclaimer }}</em>
                    </p>
                  </div>
                }
                @if (process === "start") {
                  <mat-radio-button value="switch" class="schedule-radio"
                    ><p [innerHTML]="pageLabels.marketSwitchOptionText | safe: 'SafeHtml'"></p
                  ></mat-radio-button>
                }
                @if (scheduleServiceForm.get("ServiceOption")?.value === "switch") {
                  <div class="switch-container">
                    <h3>{{ pageLabels.switchSubHeader }}</h3>
                    <mat-form-field appearance="outline" color="primary">
                      <mat-label>{{ pageLabels.providerLabelText }}</mat-label>
                      <mat-select formControlName="Provider" aria-labelledby="providerRequiredError">
                        @for (provider of pageLabels.providerList; track provider) {
                          <mat-option value="{{ provider.providerValue }}">{{ provider.providerName }}</mat-option>
                        }
                      </mat-select>
                      @if (scheduleServiceForm.get("Provider")?.hasError("required")) {
                        <mat-error id="providerRequiredError">{{ pageLabels.providerError }}</mat-error>
                      }
                    </mat-form-field>
                  </div>
                }
              </mat-radio-group>
              @if (
                scheduleServiceForm.get("ServiceOption")?.hasError("required") &&
                scheduleServiceForm.get("ServiceOption")?.touched
              ) {
                <mat-error id="serviceOptionRequiredError">{{ pageLabels.serviceTypeRequiredError }}</mat-error>
              }
            </form>
          </div>
          <div class="schudle-service-side-container">
            @if (this.ssmData.CurrentProcess !== "reconnect") {
              <app-ssm-side-panel [panelData]="ssmData" [step]="step"></app-ssm-side-panel>
            }
          </div>
        </div>
        <div class="submit-button-section">
          <mat-divider></mat-divider>
          <div class="submit-cta-container" [class.reconnect-flex-fix]="this.ssmData.CurrentProcess === 'reconnect'">
            @if (this.ssmData.CurrentProcess !== "reconnect") {
              <a [routerLink]="goBack()">{{ pageLabels.backButtonText }}</a>
            }
            <button
              id="schedule-service-submit"
              class="gs-form-button-primary"
              mat-flat-button
              color="primary"
              (click)="handleSubmitButtonPress()"
            >
              {{ pageLabels.nextButtonText }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </main>
}
